import React, { useEffect,useState } from 'react';

import CalendarHeader from '../../Components/calendrier/CalendarHeader';
import MonthCalendrier from '../../Components/calendrier/MonthCalendrier';
//import RDVModal from '../../Components/calendrier/RDVModal';
import DialogInterviewerCandidature from '../../Components/Dialogs/DialogInterviewerCandidature';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useCraRdv from '../../hooks/useCraRdv';
import useRole from '../../hooks/useRole';
import { formatDateToRdvFormat } from '../../Utils/utils';

function AllRdvs() {
    const axiosPrivate = useAxiosPrivate();
    const {openNestedInterviewerCandidature } = useCraRdv();
    // ? used for RDV calendar only
    //const { showRDV } = useCraRdv();
    const [rdvs, setRdvs] = useState([]);

    const role = useRole();
    useEffect(() => {
        // * was closed
        console.log('rdvs rdvs',rdvs);
    }, [rdvs]);

    useEffect(() => {
        // * was closed
        if(role && !openNestedInterviewerCandidature)
            getAllRDVs();
    }, [role,openNestedInterviewerCandidature]);

    const getAllRDVs = async () => {
        try {
            let requestUrl;
            if (role == 'admin') {
                requestUrl ='/candidature/getAllRDVs';
            } else if (role == 'client' || role == 'expert' || role == 'esn') {
                requestUrl='/candidature/getAllMyRDVs';
            }
            const response = await axiosPrivate.get(requestUrl);
            let rdvsReadOnly = response.data?.rdvsReadOnly || [];
            let rdvs = response.data?.rdvs || [];
            //Pour la différence entre ESN dans le cas client et le cas expert (readOnly : true -> l'ESN joue le rôle de l'expert
            rdvsReadOnly = rdvsReadOnly.map(rdv => ({ ...rdv, readOnly: true }));
            let receivedRdvs = [...rdvsReadOnly, ...rdvs];
            // let receivedRdvs = response.data?.rdvs;
            receivedRdvs.map((rdv)=> {
                rdv.date = formatDateToRdvFormat(rdv.date);
                return rdv;
            });
            console.log('receivedRdvs',receivedRdvs);
            setRdvs(receivedRdvs);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <div
                // className="h-screen flex flex-col"
                style={{
                    //position: 'absolute',
                    //left: '300px',
                    //top: '100px',
                    // * tailwind to css
                    // ? https://tailwind-to-css.vercel.app/
                    display: 'flex',
                    flexDirection: 'column',
                    alignSelf:'stretch',
                    gap:'12px',
                    //? height of the screen: height: '100vh',
                }}
            >
                <CalendarHeader />
                <div
                // className="flex flex-1"
                    style={{display: 'flex',
                        flex: '1 1 0%',
                        //marginBottom: '200px',
                        alignSelf:'stretch',
                        //marginRight: '80px',
                    }}
                >
                    {/* <aside className="border p-5 w-64">
                        <SmallCalendar />
                    </aside> */}
                    <MonthCalendrier
                        evts={rdvs}
                    />
                </div>
            </div>
            {openNestedInterviewerCandidature && <DialogInterviewerCandidature />}
        </>
    );
}

export default AllRdvs;
// aoId={selectedRDV?.candidatureId?.aoId?._id}
// expertId={selectedRDV?.candidatureId?.expertId?._id}
// selectedRDV={selectedRDV}